exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-edit-input-group-dialog .create-edit-input-group-form span {\n  color: #9ba0aa;\n  font-size: 11px;\n}\n.create-edit-input-group-dialog .create-edit-input-group-form .custom-structure {\n  margin: 0;\n}\n.create-edit-input-group-dialog .create-edit-input-group-form .custom-structure .custom-structure-label {\n  display: inline-flex;\n  height: 22px;\n  gap: 5px;\n}\n.create-edit-input-group-dialog .create-edit-input-group-form .custom-structure .ant-form-item {\n  margin: 0;\n}\n.create-edit-input-group-dialog .create-edit-input-group-form .custom-structure .ant-radio-wrapper {\n  display: block;\n}\n", ""]);

// exports
